module.exports = __webpack_public_path__ + "static/media/BackButton_72dpi.65df71f8.png";